module.exports = __webpack_public_path__ + "static/img/0.c7ad178.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide/0.jpg
// module id = 8fMK
// module chunks = 1